import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label, FormGroup, Col } from 'reactstrap';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import './RemoveAliasModal.css';

class RemoveAliasModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.data)) {
            let newData = nextProps.data;
            newData.countryName = _.get(this.props.translation, sharedLabelsPath.countries + '.' + newData.countryCode);
            this.setState({
                data: newData                
            });
        } else {
            this.clearData();
        }
    }

    render() {
        if (this.state.data) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.onCancelHandle} className="remove-alias-modal-container">
                    <ModalBody>
                        <FormWrapper
                            successMessage={_.get(this.props.translation, 'aliases.remove_success_message')}
                        >
                            <h5>{_.get(this.props.translation, 'aliases.remove_title')}</h5>
                            {this.renderAliasData()}
                            <div className="modal-buttons-container">
                                <Button color='secondary' onClick={this.onCancelHandle}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                                <Button className="olive-green-btn" onClick={this.onRemoveHandle}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                            </div>
                        </FormWrapper>
                    </ModalBody>
                </Modal>
            );
        } else {
            return null;
        }
    }

    renderAliasData = () => {
        let paramsList = [
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            },
            {
                value: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label)
            },
            {
                value: "countryName",
                title: _.get(this.props.translation, sharedLabelsPath.country_label)
            }
        ];

        return [..._.map(paramsList, this.getLabel)];
    };

    getLabel = (params) => {
        return (
            <FormGroup row key={params.title}>
                <Col sm={4}>
                    <h6>{params.title + ":"}</h6>
                </Col>
                <Col sm={8}>
                    <Label>{this.state.data[params.value]}</Label>
                </Col>
            </FormGroup>
        );
    };

    onCancelHandle = () => {
        this.clearData();
        this.props.onCancel();
    };

    onRemoveHandle = () => {
        this.props.onRemove(this.props.id);
    };

    clearData = () => {
        this.setState({
            data: null
        });
    };
}

RemoveAliasModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    id: PropTypes.string,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func
};

export default RemoveAliasModal;



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/removeAliasModal/RemoveAliasModal.js